import { Env } from 'types/env/Env.type';
import { appStore, envAtom, setAppStore } from './app.store';

interface StateService {
  getEnv: () => Env;
  setStore: (environmentConfig: Env) => void;
}

export const stateService: StateService = {
  getEnv: (): Env => appStore.get(envAtom)!,
  setStore: (environmentConfig: Env): void => {
    setAppStore(environmentConfig);
  }
};
